module.exports = __webpack_public_path__ + "static/media/500.82050302.svg";